module.exports = __webpack_public_path__ + "img/food.a2a3aae6.png";